import Branches from "./branches/main";
import Kanso from "./kanso/main";
import UI from "./ui/main";

export default class Main {
    constructor() {
        this._init();
    }

    _init() {
        window.manabiKansoSP = new Kanso();
        this.branches = new Branches();
        this.ui = new UI();
    }
}
